export const UPDATE_COUNTRY = 'UPDATE_COUNTRY';
export const UPDATE_CONFIGURATION = 'UPDATE_CONFIGURATION';
export const UPDATE_IS_AUTHORIZED = 'UPDATE_IS_AUTHORIZED';
export const UPDATE_REFERRER = 'UPDATE_REFERRER';

export const SET_COUNTRY = 'SET_COUNTRY';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_PHONE_CODE = 'SET_PHONE_CODE';
export const SET_PHONE_NUMBER = 'SET_PHONE_NUMBER';
export const SET_CLIENT_TYPE = 'SET_CLIENT_TYPE';
export const SET_INN = 'SET_INN';
export const SET_VAT = 'SET_VAT';
export const SET_FIRST_NAME = 'SET_FIRST_NAME';
export const SET_LAST_NAME = 'SET_LAST_NAME';
// export const SET_POST_ADDRESS = 'SET_POST_ADDRESS'
export const SET_ADDITIONAL_POST_ADDRESS = 'SET_ADDITIONAL_POST_ADDRESS';
export const SET_REAL_POST_ADDRESS_INDEX = 'SET_REAL_POST_ADDRESS_INDEX';
export const SET_REAL_POST_ADDRESS_CITY = 'SET_REAL_POST_ADDRESS_CITY';
export const SET_REAL_POST_ADDRESS_STREET = 'SET_REAL_POST_ADDRESS_STREET';
export const SET_REAL_POST_ADDRESS_HOUSE = 'SET_REAL_POST_ADDRESS_HOUSE';
export const SET_REAL_POST_ADDRESS_BUILDING = 'SET_REAL_POST_ADDRESS_BUILDING';
export const SET_REAL_POST_ADDRESS_OFFICE = 'SET_REAL_POST_ADDRESS_OFFICE';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_PASSWORD = 'SET_PASSWORD';
export const SET_REPEAT_PASSWORD = 'SET_REPEAT_PASSWORD';
export const SET_RETURN_URL = 'SET_RETURN_URL';
export const SET_COOKIE = 'SET_COOKIE';
export const SET_SMS_CODE = 'SET_SMS_CODE';
export const SET_SMS_CODE_VALID = 'SET_SMS_CODE_VALID';
export const SET_EMAIL_CODE = 'SET_EMAIL_CODE';
export const SET_EMAIL_CODE_VALID = 'SET_EMAIL_CODE_VALID';
